/*
 * policy-title-fix.js — Refund Policy heading override (IT)
 * ---------------------------------------------------------
 * WHY: Shopify renders /policies/* with its OWN native template
 * (.shopify-policy__container / __title / __body). The page heading comes from
 * the policy's SYSTEM title, which for IT is "Informativa sui rimborsi" — narrow
 * (only "rimborsi"/refunds) and inconsistent with the rest of the site, which
 * already labels this policy "Politica di reso" (locales/it.json → product.general.refund_policy).
 * That system title is NOT editable via Settings → Policies (body only), the
 * Admin API (ShopPolicy exposes no translatable `title`), or a theme template
 * (Shopify owns the policy render). So we relabel it client-side.
 *
 * WHAT: on the IT refund-policy page only, swap the visible <h1> text
 * "Informativa sui rimborsi" → "Politica di reso". The SEO <title> is fixed
 * server-side in layout/theme.liquid (no flash); the document.title line below
 * is a harmless fallback. Matching the exact IT string means EN ("Refund policy")
 * is never touched. Loaded only on policy pages (see theme.liquid include).
 *
 * Term rationale: "Politica di reso" is the legally precise label (reso ≠ recesso
 * ≠ rimborso). See CLAUDE.md → "Policy heading override (refund, IT)".
 */
(function () {
  var FROM = 'Informativa sui rimborsi';
  var TO = 'Politica di reso';
  function fix() {
    var h1 = document.querySelector('.shopify-policy__title h1');
    if (h1 && h1.textContent.trim() === FROM) {
      h1.textContent = TO;
    }
    if (document.title.indexOf(FROM) !== -1) {
      document.title = document.title.replace(FROM, TO);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
